import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const batchesFinalizationContract = c.router({
  retrieveFinalizeDeclarationsInfo: {
    method: 'GET',
    path: '/batches/:id/retrieve-finalize-declarations-info',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({ declaration: z.any().nullable() }),
    },
  },
  saveFinalizeDataToAllDeclarations: {
    method: 'PATCH',
    path: '/batches/:id/save-finalize-data-to-all-declarations',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      partialDeclaration: z.any(),
      partialGoodsShipmentItem: z.any(),
      commodityCodes: z.any(),
    }),
    responses: {
      200: z.object({}),
    },
  },
  finalizeDeclarations: {
    method: 'POST',
    path: '/batches/:id/finalize-declarations',
    pathParams: z.object({ id: z.string() }),
    body: z.object({ movementReferenceNumber: z.string().optional() }),
    responses: {
      200: z.object({}),
    },
  },
  retrieveAdditionalCodes: {
    method: 'PATCH',
    path: '/batches/:id/retrieve-additional-codes',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  firstDeclaration: {
    method: 'POST',
    path: '/batches/:id/first-declaration',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
});
